// @flow
import React from 'react';

import { Modal } from 'Components/frameworks/modal/Modal.jsx';
import { PricingTable } from 'Components/frameworks/pricing-table/PricingTable.jsx';
import { isTour } from 'Components/utils/product/product.utils';
import {
  getIcons,
  getInfos,
  getLabel,
} from 'Components/widgets/product-price-modal/ProductPriceModal.utils';
import { t } from 'Src/i18n';

type Props = {
  isVisible: boolean,
  onClick?: (e: SyntheticEvent<*>) => void,
  price: null | ProductPrice,
  setIsVisible: boolean => void,
  tourDuration?: null | string,
  type: string,
};

export const ProductPriceModal = ({
  isVisible,
  setIsVisible,
  onClick,
  price,
  tourDuration,
  type,
}: Props) => {
  const buttonLabel = isTour(type)
    ? t('resort.pricePopin.buttonTourLabel')
    : t('resort.pricePopin.buttonLabel');

  const button = {
    children: buttonLabel,
    onClick,
  };

  const label = getLabel({ type });

  return (
    isVisible && (
      <Modal
        ariaLabel={label}
        className="p-3"
        closeLabel={t('common.close')}
        size="auto"
        onClose={event => {
          event.preventDefault();
          setIsVisible(false);
        }}
      >
        <PricingTable
          button={button}
          icons={getIcons({ price, type })}
          infos={getInfos({ price, tourDuration, type })}
          label={label}
          price={{
            bestPrice: price?.bestPrice,
            from: t('price.format.from'),
            hasInitialPrice: !!price?.initialPrice?.value,
            initialPrice: price?.initialPrice,
            instead: t('price.format.instead'),
            unit: price?.unit,
            viewRates: t('price.format.viewRates'),
          }}
        />
      </Modal>
    )
  );
};
